"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createGroupAminoConverters = createGroupAminoConverters;
function createGroupAminoConverters() {
    // Missing, see https://github.com/cosmos/cosmjs/issues/1441
    return {};
}
//# sourceMappingURL=aminomessages.js.map